import { NgModule } from '@angular/core';
import { IonicVhframeworksComponent } from './ionic-vhframeworks.component';



@NgModule({
  declarations: [
    IonicVhframeworksComponent
  ],
  imports: [
  ],
  exports: [
    IonicVhframeworksComponent
  ]
})
export class IonicVhframeworksModule { }
